// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReassignModal-module__modalOverlay___Yq2W_ {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.ReassignModal-module__modalCard___FR_cV {
  width: 100%;
  max-width: 380px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 10px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.ReassignModal-module__modalHeader____lGwz {
  padding: 14px 16px;
  border-bottom: 1px solid #f4f4f5;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
}

.ReassignModal-module__modalTitle___HPfG2 {
  font-size: 14px;
  font-weight: 600;
  color: #18181b;
}

.ReassignModal-module__modalSubtitle___T1reP {
  margin-top: 2px;
  font-size: 11px;
  color: #71717a;
}

.ReassignModal-module__modalCloseButton___QLULe {
  background: none;
  border: none;
  font-size: 18px;
  color: #a1a1aa;
  cursor: pointer;
  line-height: 1;
  padding: 0;
}

.ReassignModal-module__modalCloseButton___QLULe:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.ReassignModal-module__modalBody___kjbna {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ReassignModal-module__modalTaskLabel___brKG7 {
  font-size: 12px;
  font-weight: 600;
  color: #18181b;
}

.ReassignModal-module__modalText___aoEWp {
  margin: 6px 0 0;
  font-size: 12px;
  color: #52525b;
  line-height: 1.5;
}

.ReassignModal-module__searchInput___iREus {
  width: 100%;
  font-size: 12px;
  color: #18181b;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #fafafa;
  padding: 8px 10px;
}

.ReassignModal-module__searchInput___iREus:focus {
  outline: none;
  border-color: #18181b;
}

.ReassignModal-module__list___cQomK {
  max-height: 280px;
  overflow-y: auto;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
}

.ReassignModal-module__emptyState___qWOP4 {
  padding: 20px 12px;
  font-size: 12px;
  color: #a1a1aa;
  text-align: center;
}

.ReassignModal-module__listItem___zfxMa {
  width: 100%;
  border: none;
  background: #ffffff;
  border-bottom: 1px solid #f4f4f5;
  padding: 9px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  cursor: pointer;
  text-align: left;
}

.ReassignModal-module__listItem___zfxMa:last-child {
  border-bottom: none;
}

.ReassignModal-module__listItem___zfxMa:disabled {
  cursor: default;
  opacity: 0.6;
}

.ReassignModal-module__listItem___zfxMa:not(:disabled):hover {
  background: #fafafa;
}

.ReassignModal-module__listItemInfo___gB50q {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ReassignModal-module__listItemName___F6l8V {
  font-size: 12px;
  font-weight: 500;
  color: #18181b;
}

.ReassignModal-module__listItemRole___GU02n {
  font-size: 10px;
  color: #a1a1aa;
}

.ReassignModal-module__currentOwnerTag___WVSEU {
  font-size: 10px;
  font-weight: 600;
  color: #52525b;
  border: 1px solid #d4d4d8;
  border-radius: 999px;
  padding: 2px 7px;
}

.ReassignModal-module__selectedMark___MbyTN {
  font-size: 13px;
  font-weight: 700;
  color: #18181b;
}

.ReassignModal-module__modalFooter___Wh5op {
  padding: 12px 16px;
  border-top: 1px solid #f4f4f5;
  display: flex;
  gap: 6px;
}

.ReassignModal-module__modalSecondaryAction___uNOXd {
  flex: 1;
  padding: 8px 0;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #3f3f46;
  cursor: pointer;
}

.ReassignModal-module__modalSecondaryAction___uNOXd:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.ReassignModal-module__modalPrimaryAction___A5Awx {
  flex: 1;
  padding: 8px 0;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  border: none;
  background: #18181b;
  color: #fafafa;
  cursor: pointer;
}

.ReassignModal-module__modalPrimaryAction___A5Awx:disabled {
  background: #f4f4f5;
  color: #a1a1aa;
  cursor: default;
}

.ReassignModal-module__modalPrimaryAction___A5Awx:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ReassignModal/ReassignModal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;AACF;;AAEA;EACE,0BAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,QAAA;AACF;;AAEA;EACE,OAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,0BAAA;EACA,mBAAA;AACF;;AAEA;EACE,OAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,0BAAA;EACA,mBAAA;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n.modalCard {\n  width: 100%;\n  max-width: 380px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 10px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n}\n\n.modalHeader {\n  padding: 14px 16px;\n  border-bottom: 1px solid #f4f4f5;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.modalTitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.modalSubtitle {\n  margin-top: 2px;\n  font-size: 11px;\n  color: #71717a;\n}\n\n.modalCloseButton {\n  background: none;\n  border: none;\n  font-size: 18px;\n  color: #a1a1aa;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n}\n\n.modalCloseButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.modalBody {\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.modalTaskLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.modalText {\n  margin: 6px 0 0;\n  font-size: 12px;\n  color: #52525b;\n  line-height: 1.5;\n}\n\n.searchInput {\n  width: 100%;\n  font-size: 12px;\n  color: #18181b;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  background: #fafafa;\n  padding: 8px 10px;\n}\n\n.searchInput:focus {\n  outline: none;\n  border-color: #18181b;\n}\n\n.list {\n  max-height: 280px;\n  overflow-y: auto;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #ffffff;\n}\n\n.emptyState {\n  padding: 20px 12px;\n  font-size: 12px;\n  color: #a1a1aa;\n  text-align: center;\n}\n\n.listItem {\n  width: 100%;\n  border: none;\n  background: #ffffff;\n  border-bottom: 1px solid #f4f4f5;\n  padding: 9px 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  cursor: pointer;\n  text-align: left;\n}\n\n.listItem:last-child {\n  border-bottom: none;\n}\n\n.listItem:disabled {\n  cursor: default;\n  opacity: 0.6;\n}\n\n.listItem:not(:disabled):hover {\n  background: #fafafa;\n}\n\n.listItemInfo {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.listItemName {\n  font-size: 12px;\n  font-weight: 500;\n  color: #18181b;\n}\n\n.listItemRole {\n  font-size: 10px;\n  color: #a1a1aa;\n}\n\n.currentOwnerTag {\n  font-size: 10px;\n  font-weight: 600;\n  color: #52525b;\n  border: 1px solid #d4d4d8;\n  border-radius: 999px;\n  padding: 2px 7px;\n}\n\n.selectedMark {\n  font-size: 13px;\n  font-weight: 700;\n  color: #18181b;\n}\n\n.modalFooter {\n  padding: 12px 16px;\n  border-top: 1px solid #f4f4f5;\n  display: flex;\n  gap: 6px;\n}\n\n.modalSecondaryAction {\n  flex: 1;\n  padding: 8px 0;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  border: 1px solid #d4d4d8;\n  background: #ffffff;\n  color: #3f3f46;\n  cursor: pointer;\n}\n\n.modalSecondaryAction:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.modalPrimaryAction {\n  flex: 1;\n  padding: 8px 0;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  border: none;\n  background: #18181b;\n  color: #fafafa;\n  cursor: pointer;\n}\n\n.modalPrimaryAction:disabled {\n  background: #f4f4f5;\n  color: #a1a1aa;\n  cursor: default;\n}\n\n.modalPrimaryAction:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `ReassignModal-module__modalOverlay___Yq2W_`,
	"modalCard": `ReassignModal-module__modalCard___FR_cV`,
	"modalHeader": `ReassignModal-module__modalHeader____lGwz`,
	"modalTitle": `ReassignModal-module__modalTitle___HPfG2`,
	"modalSubtitle": `ReassignModal-module__modalSubtitle___T1reP`,
	"modalCloseButton": `ReassignModal-module__modalCloseButton___QLULe`,
	"modalBody": `ReassignModal-module__modalBody___kjbna`,
	"modalTaskLabel": `ReassignModal-module__modalTaskLabel___brKG7`,
	"modalText": `ReassignModal-module__modalText___aoEWp`,
	"searchInput": `ReassignModal-module__searchInput___iREus`,
	"list": `ReassignModal-module__list___cQomK`,
	"emptyState": `ReassignModal-module__emptyState___qWOP4`,
	"listItem": `ReassignModal-module__listItem___zfxMa`,
	"listItemInfo": `ReassignModal-module__listItemInfo___gB50q`,
	"listItemName": `ReassignModal-module__listItemName___F6l8V`,
	"listItemRole": `ReassignModal-module__listItemRole___GU02n`,
	"currentOwnerTag": `ReassignModal-module__currentOwnerTag___WVSEU`,
	"selectedMark": `ReassignModal-module__selectedMark___MbyTN`,
	"modalFooter": `ReassignModal-module__modalFooter___Wh5op`,
	"modalSecondaryAction": `ReassignModal-module__modalSecondaryAction___uNOXd`,
	"modalPrimaryAction": `ReassignModal-module__modalPrimaryAction___A5Awx`
};
module.exports = ___CSS_LOADER_EXPORT___;
